import {Component, OnInit, AfterViewInit} from '@angular/core';
import {ModeratAnfrage} from "../anfrage/moderat.anfrage";
import {BestandsaufnahmeStepComponent} from "./bestandsaufnahme.step.component";

/**
 *
 */
@Component({
    selector: 'app-moderat-bestandsaufnahme-start',
    templateUrl: './bestandsaufnahme.start.component.html',
    standalone: false
})
export class BestandsaufnahmeStartComponent extends BestandsaufnahmeStepComponent implements OnInit, AfterViewInit {
  /**
   * The current users path
   */
  path: string = ModeratAnfrage.PATH_EXPLO;

  /**
   * @inheritDoc
   */
  ngOnInit() {
    super.ngOnInit();

    this.path = this.anfrage.getPath();
  }

  /**
   * @inheritDoc
   */
  ngAfterViewInit() {
    super.ngAfterViewInit();

    // scroll to the top
    this.elementService.scrollToElement(this.stepForm.nativeElement);
  }
}
